/* eslint-disable react/jsx-key */
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useRef } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { openCompareRoutes, comparisonRouteData } from '../../common/atom/atoms';
import ClearIcon from '@mui/icons-material/Clear';
import Tooltip from '@mui/material/Tooltip';
import { formatAmount } from '../../common/functions/format_string_elipsis.function';

export default function CompareRoutes(props) {
  const [open, setOpen] = useAtom(openCompareRoutes);
  const compareData = useAtomValue(comparisonRouteData);
  const routeCount = Array.isArray(compareData?.data) ? compareData.data.length : 0;
  const isFewRoutes = routeCount <= 2;
  const masterROWs =
    (Array.isArray(compareData?.data) &&
      compareData.data.find((r) => Array.isArray(r?.ROWs) && r.ROWs.length > 0)?.ROWs) ||
    [];
  const cardsScrollRef = useRef(null);
  const modalWidthPx =
    routeCount <= 0 ? 900 : routeCount === 1 ? 640 : routeCount === 2 ? 980 : 1200;
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: '5px',
    p: 0,
    width: `min(${modalWidthPx}px, 96vw)`,
    maxHeight: '92vh',
    overflow: 'hidden',
  };
  const colors = [
    'var(--colors-base-warning-50, #FEFCE8)',
    'var(--colors-base-warning-50, #E8FAF0)',
    'var(--colors-base-warning-50, #E6F1FE)',
    'var(--colors-base-warning-50, #FDEDD3)',
  ];
  const handleCloseModal = () => {
    setOpen(false);
  };
  const totalCostColor = ['#E4DFB1', '#C0FFDC', '#CBE3FF', '#FFE3B4'];
  return (
    <div>
      <Modal
        open={open}
        onClose={() => {
          handleCloseModal();
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              width: '100%',
              height: '100%',
              background: 'white',
              borderRadius: 8,
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: 8,
              display: 'flex',
            }}
          >
            <div
              style={{
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
                display: 'flex',
                padding: '16px 16px 10px 16px',
                borderBottom: '1px solid #E5E9EB',
              }}
            >
              <div
                style={{
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <div
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    color: 'black',
                    fontSize: 20,
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  Routes Comparison
                </div>
                <ClearIcon style={{ cursor: 'pointer' }} onClick={() => handleCloseModal()} />
              </div>
            </div>
            <div
              style={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: 8,
                display: 'flex',
                flex: 1,
                minHeight: 0,
                padding: 16,
                overflow: 'hidden',
                width: '100%',
              }}
            >
              <div
                style={{
                  width: 160,
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  gap: 8,
                  display: 'flex',
                  flex: '0 0 160px',
                  overflowY: 'auto',
                  maxHeight: '100%',
                }}
              >
                <div
                  style={{
                    alignSelf: 'stretch',
                    padding: 16,
                    background: 'var(--colors-base-default-100, #F4F4F5)',
                    borderRadius: 8,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 22,
                    display: 'flex',
                  }}
                >
                  <div
                    style={{
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Lock Routes
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: 'stretch',
                    padding: 16,
                    background: 'var(--colors-base-default-100, #F4F4F5)',
                    borderRadius: 8,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 16,
                    display: 'flex',
                  }}
                >
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Origin
                  </div>
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Designation
                  </div>
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Length (mtrs)
                  </div>
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Deploypment cost
                  </div>
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Row cost
                  </div>
                </div>

                <div
                  style={{
                    alignSelf: 'stretch',
                    padding: 16,
                    background: 'var(--colors-base-default-100, #F4F4F5)',
                    borderRadius: 8,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 16,
                    display: 'flex',
                  }}
                >
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '700',
                      wordWrap: 'break-word',
                    }}
                  >
                    Deployment cost
                  </div>
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Normal
                  </div>
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Rocky
                  </div>
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Bridge Attachment
                  </div>
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Asphalt
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: 'stretch',
                    padding: 16,
                    background: 'var(--colors-base-default-100, #F4F4F5)',
                    borderRadius: 8,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 16,
                    display: 'flex',
                  }}
                >
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '700',
                      wordWrap: 'break-word',
                    }}
                  >
                    Row
                  </div>
                  {masterROWs?.length > 0 &&
                    masterROWs.map((rowItem, rowIndex) => {
                      // Parse start_location and end_location from JSON strings
                      let startCoord = '-';
                      let endCoord = '-';

                      try {
                        if (rowItem.start_location) {
                          // Handle the format: "{\"70.96266\",\"32.29937\"}"
                          const cleanStart = rowItem.start_location
                            .replace(/\\"/g, '"')
                            .replace(/^"|"$/g, '');
                          console.log('cleanStart:', cleanStart);
                          const startCoords = JSON.parse(cleanStart);
                          console.log('startCoords:', startCoords);
                          if (Array.isArray(startCoords) && startCoords.length >= 2) {
                            startCoord = parseFloat(startCoords[0]).toFixed(1);
                          }
                        }
                        if (rowItem.end_location) {
                          // Handle the format: "{\"70.60745\",\"31.51064\"}"
                          const cleanEnd = rowItem.end_location
                            .replace(/\\"/g, '"')
                            .replace(/^"|"$/g, '');
                          console.log('cleanEnd:', cleanEnd);
                          const endCoords = JSON.parse(cleanEnd);
                          console.log('endCoords:', endCoords);
                          if (Array.isArray(endCoords) && endCoords.length >= 2) {
                            endCoord = parseFloat(endCoords[0]).toFixed(1);
                          }
                        }
                      } catch (error) {
                        console.log('Error parsing coordinates:', error);
                        console.log('start_location:', rowItem.start_location);
                        console.log('end_location:', rowItem.end_location);
                        // Fallback: try to extract coordinates using regex
                        try {
                          const startMatch = rowItem.start_location.match(/"([^"]+)"/);
                          if (startMatch) {
                            startCoord = parseFloat(startMatch[1]).toFixed(1);
                          }
                          const endMatch = rowItem.end_location.match(/"([^"]+)"/);
                          if (endMatch) {
                            endCoord = parseFloat(endMatch[1]).toFixed(1);
                          }
                        } catch (fallbackError) {
                          console.log('Fallback parsing also failed:', fallbackError);
                        }
                      }

                      return (
                        <div
                          key={rowIndex}
                          style={{
                            alignSelf: 'stretch',
                            justifyContent: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            color: 'black',
                            fontSize: 14,
                            fontFamily: 'Inter',
                            fontWeight: '500',
                            wordWrap: 'break-word',
                            marginBottom: rowIndex < masterROWs.length - 1 ? '8px' : '0',
                          }}
                        >
                          {startCoord} to {endCoord}
                        </div>
                      );
                    })}
                </div>
                <div
                  style={{
                    alignSelf: 'stretch',
                    padding: 16,
                    background: 'var(--colors-base-default-200, #E4E4E7)',
                    borderRadius: 8,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 22,
                    display: 'flex',
                  }}
                >
                  <div
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'black',
                      fontSize: 14,
                      fontFamily: 'Inter',
                      fontWeight: '700',
                      wordWrap: 'break-word',
                    }}
                  >
                    Total Cost
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flex: 1,
                  minWidth: 0,
                  overflowX: isFewRoutes ? 'hidden' : 'auto',
                  overflowY: 'auto',
                  maxHeight: '100%',
                  scrollbarGutter: 'stable both-edges',
                  WebkitOverflowScrolling: 'touch',
                }}
                ref={cardsScrollRef}
                onWheel={(e) => {
                  // Make horizontal scrolling work even when user scrolls vertically
                  // (common issue on Windows mouse wheels; trackpads still work naturally).
                  if (isFewRoutes) {
                    return;
                  }
                  const el = cardsScrollRef.current;
                  if (!el) {
                    return;
                  }
                  if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && !e.shiftKey) {
                    el.scrollLeft += e.deltaY;
                    e.preventDefault();
                  }
                }}
              >
                {compareData?.data?.length ? (
                  <div
                    style={{
                      display: 'flex',
                      gap: 10,
                      flex: '0 0 auto', // prevent flexbox from shrinking the strip (enables real horizontal overflow)
                      // For 1–2 routes, fill width so cards can expand; for 3+ keep content-width for scrolling.
                      width: isFewRoutes ? '100%' : 'max-content',
                      justifyContent: isFewRoutes ? 'stretch' : 'flex-start',
                      paddingBottom: 8,
                    }}
                  >
                    {compareData?.data.map((row, index) => (
                      <div
                        style={{
                          width: isFewRoutes ? 'auto' : 273,
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                          gap: 8,
                          display: 'flex',
                          // Expand to remove empty space when only 1–2 routes; fixed width for 3+ routes.
                          flex: isFewRoutes ? '1 1 420px' : '0 0 273px',
                          minWidth: 273,
                          maxWidth: isFewRoutes ? (routeCount === 1 ? 900 : 560) : 273,
                        }}
                      >
                        <div
                          style={{
                            alignSelf: 'stretch',
                            padding: 16,
                            background: colors[index % colors.length],
                            borderRadius: 8,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            gap: 16,
                            display: 'flex',
                          }}
                        >
                          <div
                            style={{
                              justifyContent: 'center',
                              display: 'flex',
                              flexDirection: 'column',
                              color: 'black',
                              fontSize: 16,
                              fontFamily: 'Inter',
                              fontWeight: '700',
                              wordWrap: 'break-word',
                            }}
                          >
                            {row.routeName}
                          </div>
                        </div>
                        <div
                          style={{
                            alignSelf: 'stretch',
                            padding: 16,
                            background: colors[index % colors.length],
                            borderRadius: 8,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            gap: 16,
                            display: 'flex',
                          }}
                        >
                          <div
                            style={{
                              alignSelf: 'stretch',
                              flexDirection: 'column',
                              justifyContent: 'flex-start',
                              alignItems: 'flex-start',
                              gap: 16,
                              display: 'flex',
                            }}
                          >
                            <div
                              style={{
                                alignSelf: 'stretch',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-end',
                                gap: 16,
                                display: 'flex',
                              }}
                            >
                              <div
                                style={{
                                  justifyContent: 'center',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  color: 'black',
                                  fontSize: 14,
                                  fontFamily: 'Inter',
                                  fontWeight: '300',
                                  wordWrap: 'break-word',
                                }}
                              >
                                {isNaN(parseFloat(row?.start_location))
                                  ? '-'
                                  : parseFloat(row.start_location).toFixed(3)}
                              </div>
                              <div
                                style={{
                                  justifyContent: 'center',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  color: 'black',
                                  fontSize: 14,
                                  fontFamily: 'Inter',
                                  fontWeight: '300',
                                  wordWrap: 'break-word',
                                }}
                              >
                                {isNaN(parseFloat(row?.end_location))
                                  ? '-'
                                  : parseFloat(row.end_location).toFixed(3)}
                              </div>
                            </div>
                            <div
                              style={{
                                alignSelf: 'stretch',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-end',
                                gap: 16,
                                display: 'flex',
                              }}
                            >
                              <div
                                style={{
                                  textAlign: 'right',
                                  justifyContent: 'center',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  color: 'black',
                                  fontSize: 14,
                                  fontFamily: 'Inter',
                                  fontWeight: '300',
                                  wordWrap: 'break-word',
                                }}
                              >
                                {row?.length}
                              </div>
                              <div
                                style={{
                                  textAlign: 'right',
                                  justifyContent: 'center',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  color: 'black',
                                  fontSize: 14,
                                  fontFamily: 'Inter',
                                  fontWeight: '300',
                                  wordWrap: 'break-word',
                                }}
                              >
                                -
                              </div>
                              <div
                                style={{
                                  textAlign: 'right',
                                  justifyContent: 'center',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  color: 'black',
                                  fontSize: 14,
                                  fontFamily: 'Inter',
                                  fontWeight: '300',
                                  wordWrap: 'break-word',
                                }}
                              >
                                -
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            alignSelf: 'stretch',
                            padding: 16,
                            background: colors[index % colors.length],
                            borderRadius: 8,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            gap: 16,
                            display: 'flex',
                          }}
                        >
                          <div
                            style={{
                              width: 241,
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              display: 'inline-flex',
                            }}
                          >
                            <div
                              style={{
                                width: 49,
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                gap: 16,
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  alignSelf: 'stretch',
                                  justifyContent: 'center',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  color: 'black',
                                  fontSize: 14,
                                  fontFamily: 'Inter',
                                  fontWeight: '600',
                                  wordWrap: 'break-word',
                                }}
                              >
                                Length
                              </div>
                              <Tooltip title={row.Normal.length}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row.Normal.length)}
                                </div>
                              </Tooltip>
                              <Tooltip title={row.Rocky.length}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row.Rocky.length)}
                                </div>
                              </Tooltip>
                              <Tooltip title={row['Bridge Attachment'].length}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    cursor: 'pointer',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row['Bridge Attachment'].length)}
                                </div>
                              </Tooltip>
                              <Tooltip title={row.Asphalt.length}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    cursor: 'pointer',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row.Asphalt.length)}
                                </div>
                              </Tooltip>
                            </div>
                            <div
                              style={{
                                width: 57,
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                gap: 16,
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  alignSelf: 'stretch',
                                  justifyContent: 'center',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  color: 'black',
                                  fontSize: 14,
                                  fontFamily: 'Inter',
                                  fontWeight: '600',
                                  wordWrap: 'break-word',
                                }}
                              >
                                Per-unit
                              </div>
                              <Tooltip title={row.Normal.length}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row.Normal.cost)}
                                </div>
                              </Tooltip>
                              <Tooltip title={row.Rocky.length}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row.Rocky.cost)}
                                </div>
                              </Tooltip>
                              <Tooltip title={row['Bridge Attachment'].length}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row['Bridge Attachment'].cost)}
                                </div>
                              </Tooltip>
                              <Tooltip title={row.Asphalt.length}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row.Asphalt.cost)}
                                </div>
                              </Tooltip>
                            </div>
                            <div
                              style={{
                                width: 60,
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                gap: 16,
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  alignSelf: 'stretch',
                                  justifyContent: 'center',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  color: 'black',
                                  fontSize: 14,
                                  fontFamily: 'Inter',
                                  fontWeight: '600',
                                  wordWrap: 'break-word',
                                }}
                              >
                                Amount
                              </div>
                              <Tooltip title={row.Normal.amount}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    cursor: 'pointer',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row.Normal.amount)}
                                </div>
                              </Tooltip>
                              <Tooltip title={row.Rocky.amount}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    cursor: 'pointer',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row.Rocky.amount)}
                                </div>
                              </Tooltip>
                              <Tooltip title={row['Bridge Attachment'].amount}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    cursor: 'pointer',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row['Bridge Attachment'].amount)}
                                </div>
                              </Tooltip>
                              <Tooltip title={row.Asphalt.amount}>
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '300',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {formatAmount(row.Asphalt.amount)}
                                </div>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            alignSelf: 'stretch',
                            padding: 16,
                            background: colors[index % colors.length],
                            borderRadius: 8,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            gap: 16,
                            display: 'flex',
                          }}
                        >
                          <div
                            style={{
                              alignSelf: 'stretch',
                              flexDirection: 'column',
                              justifyContent: 'flex-end',
                              alignItems: 'flex-start',
                              gap: 20,
                              display: 'flex',
                            }}
                          >
                            {/* Length Header */}
                            <div
                              style={{
                                alignSelf: 'stretch',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  width: 49,
                                  flexDirection: 'column',
                                  justifyContent: 'flex-start',
                                  alignItems: 'flex-start',
                                  gap: 16,
                                  display: 'inline-flex',
                                }}
                              >
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '600',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  Length
                                </div>
                              </div>
                              <div
                                style={{
                                  width: 57,
                                  flexDirection: 'column',
                                  justifyContent: 'flex-start',
                                  alignItems: 'flex-start',
                                  gap: 16,
                                  display: 'inline-flex',
                                }}
                              >
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '600',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  Per-unit
                                </div>
                              </div>
                              <div
                                style={{
                                  width: 60,
                                  flexDirection: 'column',
                                  justifyContent: 'flex-start',
                                  alignItems: 'flex-start',
                                  gap: 16,
                                  display: 'inline-flex',
                                }}
                              >
                                <div
                                  style={{
                                    alignSelf: 'stretch',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    color: 'black',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    fontWeight: '600',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  Amount
                                </div>
                              </div>
                            </div>
                            {/* ROWs List (keep aligned across routes) */}
                            {masterROWs?.length > 0 &&
                              masterROWs.map((_, rowIndex) => {
                                const rowItem = Array.isArray(row?.ROWs)
                                  ? row.ROWs[rowIndex]
                                  : undefined;
                                // Parse start_location and end_location from JSON strings
                                let startCoord = '-';
                                let endCoord = '-';

                                try {
                                  if (rowItem.start_location) {
                                    // Handle the format: "{\"70.96266\",\"32.29937\"}"
                                    const cleanStart = rowItem.start_location
                                      .replace(/\\"/g, '"')
                                      .replace(/^"|"$/g, '');
                                    const startCoords = JSON.parse(cleanStart);
                                    if (Array.isArray(startCoords) && startCoords.length >= 2) {
                                      startCoord = parseFloat(startCoords[0]).toFixed(1);
                                    }
                                  }
                                  if (rowItem.end_location) {
                                    // Handle the format: "{\"70.60745\",\"31.51064\"}"
                                    const cleanEnd = rowItem.end_location
                                      .replace(/\\"/g, '"')
                                      .replace(/^"|"$/g, '');
                                    const endCoords = JSON.parse(cleanEnd);
                                    if (Array.isArray(endCoords) && endCoords.length >= 2) {
                                      endCoord = parseFloat(endCoords[0]).toFixed(1);
                                    }
                                  }
                                } catch (error) {
                                  console.log('Error parsing coordinates:', error);
                                }

                                return (
                                  <div
                                    key={rowIndex}
                                    style={{
                                      alignSelf: 'stretch',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      display: 'inline-flex',
                                      marginBottom: rowIndex < masterROWs.length - 1 ? '8px' : '0',
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: 49,
                                        flexDirection: 'column',
                                        justifyContent: 'flex-start',
                                        alignItems: 'flex-start',
                                        gap: 16,
                                        display: 'inline-flex',
                                      }}
                                    >
                                      <div
                                        style={{
                                          alignSelf: 'stretch',
                                          justifyContent: 'center',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          color: 'black',
                                          fontSize: 14,
                                          fontFamily: 'Inter',
                                          fontWeight: '300',
                                          wordWrap: 'break-word',
                                        }}
                                      >
                                        {rowItem?.length == null ? '-' : Math.round(rowItem.length)}
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        width: 57,
                                        flexDirection: 'column',
                                        justifyContent: 'flex-start',
                                        alignItems: 'flex-start',
                                        gap: 16,
                                        display: 'inline-flex',
                                      }}
                                    >
                                      <div
                                        style={{
                                          alignSelf: 'stretch',
                                          justifyContent: 'center',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          color: 'black',
                                          fontSize: 14,
                                          fontFamily: 'Inter',
                                          fontWeight: '300',
                                          wordWrap: 'break-word',
                                        }}
                                      >
                                        {rowItem?.cost == null ? '-' : Math.round(rowItem.cost)}
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        width: 60,
                                        flexDirection: 'column',
                                        justifyContent: 'flex-start',
                                        alignItems: 'flex-start',
                                        gap: 16,
                                        display: 'inline-flex',
                                      }}
                                    >
                                      <Tooltip
                                        title={
                                          rowItem?.amount == null ? '-' : Math.round(rowItem.amount)
                                        }
                                      >
                                        <div
                                          style={{
                                            alignSelf: 'stretch',
                                            justifyContent: 'center',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            color: 'black',
                                            fontSize: 14,
                                            fontFamily: 'Inter',
                                            fontWeight: '300',
                                            wordWrap: 'break-word',
                                          }}
                                        >
                                          {rowItem?.amount == null
                                            ? '-'
                                            : formatAmount(Math.round(rowItem.amount))}
                                        </div>
                                      </Tooltip>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                        <div
                          style={{
                            alignSelf: 'stretch',
                            padding: 16,
                            background: totalCostColor[index % colors.length],
                            borderRadius: 8,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            gap: 16,
                            display: 'flex',
                          }}
                        >
                          <div
                            style={{
                              alignSelf: 'stretch',
                              flexDirection: 'column',
                              justifyContent: 'flex-start',
                              alignItems: 'flex-end',
                              gap: 16,
                              display: 'flex',
                            }}
                          >
                            <div
                              style={{
                                textAlign: 'right',
                                justifyContent: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                color: 'black',
                                fontSize: 14,
                                fontFamily: 'Inter',
                                fontWeight: '600',
                                wordWrap: 'break-word',
                              }}
                            >
                              {Math.round(row?.totalCost).toLocaleString()}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  'No data Found'
                )}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
